import clsx from 'clsx'
import { useEffect, useState } from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string
  focus?: boolean
}

// delay before starting animation
const START_DELAY = 500
// how long before changing back to dot
const END_DELAY = 2000

const Button: React.FC<Props> = ({ title, focus }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpanded(true)
    }, START_DELAY)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    if (isExpanded) {
      const timer = setTimeout(() => {
        setIsExpanded(false)
      }, END_DELAY)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [isExpanded])

  const active = isExpanded || focus

  return (
    <div className='relative flex items-center justify-center'>
      <div
        className={clsx(
          'absolute inset-0 z-0 translate-x-[2px] translate-y-[2px] rounded-full bg-black transition-all duration-100 ease-linear',
          { 'h-7 w-28 rounded-lg': active, 'h-3 w-3': !active }
        )}
      />
      <div
        className={clsx(
          'border-1 relative inline-flex items-center justify-center rounded-full border border-black bg-white transition-all duration-100 ease-linear',
          { 'h-7 w-28 rounded-lg': active, 'h-3 w-3': !active }
        )}
      >
        <span
          className={clsx(
            'line-clamp-1 text-ellipsis text-center text-xs text-black transition-opacity',
            {
              'opacity-100 duration-700': active,
              'opacity-0 duration-100': !active,
            }
          )}
        >
          {title}
        </span>
      </div>
    </div>
  )
}
export default Button
